<template>
  <div class="fs-range" @click="handleProgressTap">
    <span class="fs-small">小</span>
    <div ref="progress" class="fs-range-progress">
      <div class="fs-range-ticks">
        <div class="tick" :class="{ 'tick-active': t.value === value }" v-for="t in ticks" :key="t.value"
          :data-label="t.label"></div>
      </div>
      <div ref="handle" class="fs-range-handle" @touchstart="handleTouchStart" @touchmove="handleTouchMove"
        @touchend="handleTouchEnd">
        <i class="ico-font-size-drag icon-btn"></i>
      </div>
    </div>
    <span class="fs-large">大</span>
  </div>
</template>

<script>
const half = 2;
const stopDistance = 20;

export default {
  name: 'FontSizeRange',
  props: {
    value: {
      type: [String],
      default: 's',
    },
  },
  data() {
    return {
      ticks: [
        {
          value: 's',
        },
        {
          value: 'm',
        },
        {
          value: 'l',
        },
        {
          value: 'xl',
        },
        {
          value: 'xxl',
        },
      ],
      $progress: {
        offset: 0,
        width: 0,
      },
      $handle: {
        width: 0,
      },
      isMoving: false,
      handleLeftPos: {
        min: 0,
        max: 0,
      },
      stopPoints: [],
      clipsSize: 0,
    };
  },
  watch: {
    value(val) {
      this.$nextTick(() => {
        const $handle = this.$refs.handle;

        const i = this.ticks.findIndex(t => t.value === val);
        if (i !== -1) {
          $handle.style.left = `${this.stopPoints[i]}px`;
        }
      });
    },
  },
  mounted() {
    const $progress = this.$refs.progress;
    const $handle = this.$refs.handle;
    const progressWidth = $progress.offsetWidth;
    const progressOffset = $progress.offsetLeft;
    const handleWidth = $handle.offsetWidth;

    this.$progress = {
      offset: progressOffset,
      width: progressWidth,
    };
    this.$handle = {
      width: handleWidth,
    };
    this.handleLeftPos = {
      min: -handleWidth / half,
      max: progressWidth - handleWidth / half,
    };

    // 分段
    const clipsLen = this.ticks.length;
    const clipsSize = progressWidth / (clipsLen - 1);
    const stopPoints = [];

    for (let i = 0; i < clipsLen; i++) {
      stopPoints.push(clipsSize * i - handleWidth / half);
    }
    this.stopPoints = stopPoints;
    this.clipsSize = clipsSize;

    const i = this.ticks.findIndex(t => t.value === this.value);
    if (i !== -1) {
      $handle.style.left = `${this.stopPoints[i]}px`;
    }
  },
  methods: {
    handleTouchStart(e) {
      e.stopPropagation();
      this.isMoving = true;
    },
    handleTouchMove(e) {
      if (!this.isMoving) return;

      const {pageX} = e.touches[0];

      this._caculate(pageX);
    },
    handleTouchEnd() {
      this.isMoving = false;
    },
    isStopVal(val, curVal) {
      const stopVal = Math.floor(val);
      const currentVal = Math.floor(curVal);
      return (
        currentVal >= stopVal - stopDistance &&
        currentVal <= stopVal + stopDistance
      );
    },
    handleProgressTap(e) {
      const {pageX} = e;
      this._caculate(pageX);
    },
    _caculate(pointX) {
      const $handle = this.$refs.handle;
      const currentLeftPos =
        pointX - this.$progress.offset - this.$handle.width / half;

      if (
        currentLeftPos >= this.handleLeftPos.min - stopDistance &&
        currentLeftPos <= this.handleLeftPos.max + stopDistance
      ) {
        const {stopPoints} = this;
        stopPoints.forEach((p, i) => {
          if (
            this.isStopVal(p, currentLeftPos) &&
            this.ticks[i].value !== this.value
          ) {
            $handle.style.left = `${p}px`;
            this.$emit('input', this.ticks[i].value);
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.fs-range {
  font-size: 14px;
  line-height: 30px;

  .fs-small {
    font-size: 16px;
  }

  .fs-large {
    font-size: 20px;
  }

  &-progress {
    // prettier-ignore
    height: 5PX;
    width: 290px;
    background: #EEEEEE;
    position: relative;
    display: inline-block;
    margin: 0 12px;

    .fs-range-ticks {
      display: flex;
      justify-content: space-between;
      position: absolute;
      width: 100%;
      left: 0;
      top: -6px;

      .tick {
        // prettier-ignore
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: #0097F4;
        position: relative;

      }

      .tick-active {
        &::before {
          color: @color-text-highlight;
          font-size: 18px;
          font-weight: bold;
        }
      }
    }

    .fs-range-handle {
      position: absolute;
      left: 0;
      top: -9px;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 8px 0 rgba(153, 153, 153, 0.32);
      transition: 0.2s;
      color: #0097F4;
    }
  }
}

.night {
  .fs-range-progress {
    background: #252528;

    .fs-range-handle {
      background: #252528;
      box-shadow: 0 2px 8px 0 rgba(37, 37, 40, 0.32);
    }
  }
}
</style>
